import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { pageTitle } from "../../../store/softSlice";
import AppURL from "../../../widgets/AppURL";
import { fetchDataFromApi } from "../../../widgets/api";
import { Grid } from "@mui/material";
import EnthinicityMappingEditView from "../../../components/academics/setup/ethnicity_mapping/EnthinicityMappingEditView";
import EnthinicityMappingCreateView from "../../../components/academics/setup/ethnicity_mapping/EnthinicityMappingCreateView";
import EnthinicityMappingListView from "../../../components/academics/setup/ethnicity_mapping/EnthinicityMappingListView";

const EthnicityMappingCreateListView = ({ PageTitle, setIconsButton }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageTitle({ title: PageTitle }));
    document.title = `${PageTitle}`;
    setIconsButton(null);
  }, []);
  const [onEditID, setOnEditID] = useState(false);
  const [onAcaListData, setOnAcaListData] = useState([]);
  const url = AppURL.AcademicsURL + "academics-ethnicity-mapping-create-list-view/";
  const [onUpdateURL, setOnUpdateURL] = useState("");
  const fetchAcademicsListView = async (urls) => {
    setOnUpdateURL(urls);
    try {
      await fetchDataFromApi(urls).then((res) => {
        setOnAcaListData(res);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const FetchData = async () => {
    await fetchAcademicsListView(url);
  };
  useEffect(() => {
    FetchData();
  }, []);
  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xl={6} lg={6} sm={12} xs={12} md={6}>
          {onEditID ? (
            <EnthinicityMappingEditView
              setOnEditID={setOnEditID}
              fetchAcademicsListView={fetchAcademicsListView}
              onUpdateURL={onUpdateURL}
              onEditID={onEditID}
            />
          ) : (
            <EnthinicityMappingCreateView FetchData={FetchData} />
          )}
        </Grid>
        <Grid item xl={6} lg={6} sm={12} xs={12} md={6}>
          <EnthinicityMappingListView
            fetchAcademicsListView={fetchAcademicsListView}
            onAcaListData={onAcaListData}
            setOnEditID={setOnEditID}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default EthnicityMappingCreateListView;
